import { render, staticRenderFns } from "./ChartRemessasTotal.vue?vue&type=template&id=1346957e"
import script from "./ChartRemessasTotal.vue?vue&type=script&lang=js"
export * from "./ChartRemessasTotal.vue?vue&type=script&lang=js"
import style0 from "./ChartRemessasTotal.vue?vue&type=style&index=0&id=1346957e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports